import styled from 'styled-components';
import colors from 'constants/colors';
import statusColorMap from 'constants/statusColorMap';

export const StatusBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${colors.darkGrey};
  border-radius: 11px;
  font-size: ${({fontSize}) => (fontSize ? fontSize : '12px')};
  font-weight: ${({fontWeight}) => (fontWeight ? fontWeight : '600')};
  height: ${({height}) => (height ? height : '23px')};
  line-height: ${({height}) => (height ? height : '23px')};
  background:   ${({status}) =>  status ? statusColorMap[status] : statusColorMap['default']};  
  color: ${({color}) => (color? color: colors.white)};
  white-space: nowrap;
  letter-spacing: 0.5px;
  margin: ${({margin}) => (margin ? margin : '0 8px 0 15px')};
  padding: 0 11px;
`;
